import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var swiper = new Swiper(".swiper-banner", {
    centeredSlides: true,
    autoplay: {
        delay: 4500,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

var swiperSingleBlog = new Swiper(".swiper-single-blog", {
    slidesPerView: 1.5,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    loopedSlides: 5,
    autoplay: {
        delay: 2500,
    },
});

